import cache from '~/cache';

export default (
  state,
  {
    payload: {
      modal: { modalId, ...data },
    },
  }
) => {
  cache[modalId]?.resolve({ modalId, ...data });
  delete cache[modalId];
};
